import { Colors } from '../../consts/Colors';
import Obstacle from '../Obstacle';

export default class Poisson7 extends Obstacle {
    constructor(scene, x, y, params = { showHitbox: false }) {
        super(scene, x, y, params);

        this.scene = scene;
        this.type = 'poisson7';
        this.speed = 200;
        this.setPosition(x, y);
        scene.add.existing(this);
    }

    addBody(params) {
        this.texture = this.scene.add.sprite(0, 0, 'poisson7').setOrigin(0.5);
        this.texture.anims.play('poissonAnim7');
        this.add(this.texture);
    }
}
